/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Adv_3Inputs */

const en_pc_cmp_adv_3 = /** @type {(inputs: Pc_Cmp_Adv_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sign-in, no telemetry and no cloud, ideal for confidential files and offline machines.`)
};

const zh_pc_cmp_adv_3 = /** @type {(inputs: Pc_Cmp_Adv_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需登录、无遥测、不上云，非常适合机密文件和离线电脑。`)
};

/**
* | output |
* | --- |
* | "No sign-in, no telemetry and no cloud, ideal for confidential files and offline machines." |
*
* @param {Pc_Cmp_Adv_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_adv_3 = /** @type {((inputs?: Pc_Cmp_Adv_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Adv_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_adv_3(inputs)
	return zh_pc_cmp_adv_3(inputs)
});
export { pc_cmp_adv_3 as "pc.cmp.adv.3" }